import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import axios from 'axios';
import { showCustomToast, CustomToastContainer } from '../../components/CustomToast';
import 'react-toastify/dist/ReactToastify.css'; // Import Toastify CSS

const Addlinks = () => {
  const [videoCarousels, setVideoCarousels] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)


  

  const [data, setData] = useState({
    name: "",
    videos: ""
  })
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [editData, setEditData] = useState({
    _id: "",
    name: "",
    url: ""
  });
  // Fetch video carousels on component mount
  useEffect(() => {
    const fetchVideoCarousels = async () => {
      try {
        const response = await axios.get('https://api.makeeasydocuments.com/api/videoroutes/getAllVideoCarousels');
        setData(response.data);
     
        setLoading(false);
      } catch (error) {
        console.error('Error fetching video carousels:', error);
        showCustomToast('Failed to fetch video carousels. Please try again later.', 'error');
        setError('Failed to fetch video carousels.', 'error');
      } finally {
        setLoading(false);
      }
    };
    fetchVideoCarousels();
  }, [uploadSuccess ]);

  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData(prevData => ({ ...prevData, [name]: value }));
  };



  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditData(prevData => ({ ...prevData, [name]: value }));
  };

  // Handle form submission for video upload
  const handleUpload = async (e) => {
    e.preventDefault();


    try {
      const response = await axios.post(
        "https://api.makeeasydocuments.com/api/videoroutes/createVideoCarousel",
        data
      );



      // Clear input fields after successful submission
      setData({ name: "", url: "" });
      showCustomToast("created succesfully")
      setUploadSuccess((prev) => !prev)
    } catch (error) {
      showCustomToast("error creating")
      console.error("Error uploading video:", error);
      setError(error.response?.data?.message || "Something went wrong.");
    } 
  };

  // Handle edit carousel
  const handleEdit = (data) => {
    setEditData({
      _id: data._id, // ✅ Corrected
      name: data.name,
      url: data.url
    });
    setIsUpdateModalOpen(true);
  };

 

  // Handle update submission
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `https://api.makeeasydocuments.com/api/videoroutes/updateVideoCarousel/${editData._id}`,
        { name: editData.name, url: editData.url }
      );
      

      if (response.status === 200) {
        showCustomToast("Updated successfully");
        setUploadSuccess((prev) => !prev); // Trigger refetch
        closeUpdateModal();
      }
    } catch (error) {
      showCustomToast("Error updating", "error");
      console.error("Error updating video:", error);
    }
  };


  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://api.makeeasydocuments.com/api/videoroutes/deleteVideoCarousel/${id}`);
      showCustomToast("Deleted successfully");
      setVideoCarousels(videoCarousels.filter(v => v._id !== id));
      setUploadSuccess((prev) => !prev); // Trigger refetch
    } catch (error) {
      console.error("Error deleting video:", error);
      showCustomToast("Error deleting", "error");
    }
  };


   

  const openUpdateModal = () => {
    setIsUpdateModalOpen(true);
  };

  const closeUpdateModal = () => {
    setEditData({ id: "", name: "", url: "" }); // Reset form on close
    setIsUpdateModalOpen(false);
  };

  const handleOpenDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

 





  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (error) return <div className="text-center mt-10 text-red-500">{error}</div>;

  return (
    <div className='flex1'>
      <h2 className="mt-3 mx-3 mb-3 font-bold text-3xl border border-black text-blue-800 text-center bg-blue-200 p-2 lg shadow-sm transition-transform duration-300">
        Add Video Link (For User Dashboard)
      </h2>

      {/* Upload Video Form */}
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: 'auto', opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        className='overflow-x-auto w-full'
      >
        <section className="max-w-5xl p-6 mb-12 mt-10 mx-4 md:mx-auto border border-black  rounded-md shadow-xl">
          <form onSubmit={handleUpload}>
            <div className="grid justify-center grid-cols-1 gap-6 mt-4 sm:grid-cols-3">
              <div>
                <label
                  htmlFor="name"
                  className="block text-gray-600 font-semibold mb-2"
                >
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Enter the Name"
                  className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none"
                  value={data.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="url"
                  className="block text-gray-600 font-semibold mb-2"
                >
                  Paste the Link Here
                </label>
                <input
                  type="text"
                  name="url"
                  id="url"
                  placeholder="Enter the video link"
                  className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none"
                  value={data.url}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className='pt-100'>


                <button
                  type="submit"
                  className="  w-full h-[40px] mt-7 px-6 text-white transition-colors duration-300 transform bg-blue-500 rounded-md hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
                >
                  Upload
                </button>

              </div>
            </div>
          </form>
        </section>

        <table className="w-full min-w-[700px] mx-auto text-sm md:text-md lg:text-lg bg-white shadow-md rounded-lg border-collapse">
          <thead>
            <tr className="bg-gray-300">
              <th className="px-2 md:px-4 py-2 border-2 border-[#3f4b74]">Sr no</th>
              <th className="px-2 md:px-4 py-2 border-2 border-[#3f4b74]">Name</th>
              <th className="px-2 md:px-4 py-2 border-2 border-[#3f4b74]">Link of video</th>
              <th className="px-2 md:px-4 py-2 border-2 border-[#3f4b74]">Created At</th>
              <th className="px-2 md:px-4 py-2 border-2 border-[#3f4b74]">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.carousels?.map((data, index) => (
              <tr key={data._id}>
                <td className="px-2 md:px-4 py-2 border-2 border-[#3f4b74] text-center text-[#797D8C]">
                {index + 1}
                </td>
                <td className="px-2 md:px-4 py-2 border-2 border-[#3f4b74] text-[#797D8C]">
                  {data.name}
                </td>
                <td className="px-2 md:px-4 py-2 border-2 border-[#3f4b74] text-center text-[#797D8C]">
                  <a href={data.url} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                    {data.url}
                  </a>
                </td>
                <td className="px-2 md:px-4 py-2 border-2 border-[#3f4b74] text-center text-[#797D8C]">
                  {new Date(data.createdAt).toLocaleDateString()}
                </td>
                <td className="px-2 md:px-4 py-2 border-2 border-[#3f4b74] text-center text-[#797D8C]">
                  <FaEdit className="inline text-green-500 cursor-pointer" onClick={() => handleEdit(data)} />
                  <FaTrash className="inline text-red-500 cursor-pointer ml-4" onClick={() => handleDelete(data._id)}/> 
                </td>
              </tr>
            ))}
          </tbody>
        </table>

      </motion.div>

   

      {/* Edit Modal */}
      {isUpdateModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full"
          >
            <h3 className="text-lg font-semibold mb-4">Update Here</h3>
            <form onSubmit={handleUpdate}>
              <div className="mb-4">
                <label className="block text-gray-600 font-semibold mb-2" htmlFor="edit-name">
                  Name
                </label>
                <input
                  type="text"
                  id="edit-name"
                  name="name"
                  value={editData.name}
                  onChange={handleEditInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none"
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-gray-600 font-semibold mb-2" htmlFor="edit-url">
                  Video URL
                </label>
                <input
                  type="text"
                  id="edit-url"
                  name="url"
                  value={editData.url}
                  onChange={handleEditInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none"
                  required
                />
              </div>

              <div className="flex justify-end mt-6">
                <button
                  type="button"
                  className="px-4 py-2 text-gray-500 border rounded hover:bg-gray-200 mr-2"
                  onClick={closeUpdateModal}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-white bg-green-600 rounded hover:bg-green-700"
                >
                  Update
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            className="bg-white rounded-lg shadow-lg p-6"
          >
            <h3 className="text-lg font-semibold">Confirm Deletion</h3>
            <p className="mt-2">Are you sure you want to delete this video carousel?</p>
            <div className="flex justify-end mt-4">
              <button
                className="px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700 mr-2"
              >
              </button>
              <button className="px-4 py-2 text-gray-500 border rounded hover:bg-gray-200" onClick={handleCloseDeleteModal}>
                Cancel
              </button>
            </div>
          </motion.div>
        </div>
      )}







      {/* Toast Container for Notifications */}
      <CustomToastContainer />
    </div>
  );
};

export default Addlinks;
